module.exports = __webpack_public_path__ + "img/7b79a68.png";